import { TopReviews } from '@bepure/tarkin';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

declare const BASE_API_URL: string;
declare const BASE_URL: string;

interface Review {
    title: string;
    name: string;
    date: string;
    body: string;
    key: number;
    sku?: string;
    link_href?: string;
}

export default function render() {
    const elements = document.getElementsByClassName('five-star-reviews');
    Array.prototype.map.call(elements, (element: HTMLElement) => {
        getFiveStarReviews().then((r) => {
            const reviews: {
                [id: number]: Review,
            } = r ? r.reviews : {};
            if (reviews) {
                const promiseReviews = Object.keys(reviews)
                                         .map((key, index) => reviews[key])
                                         .map(review => review.body ?
                                                        review.body.split(' ').length > 35 ?
                                                        getURL(review.sku, review.key).then(url => {
                                                            return  url ? truncateReview(review, url) : truncateReview(review);
                                            }).catch((e) => {
                                                // tslint:disable-next-line: no-console
                                                console.log('Could not retrieve truncated review link: ' +  e);
                                                return truncateReview(review);
                                            }) : review : review,
                                         );
                const title = element.dataset.title ? element.dataset.title : '';
                Promise.all(promiseReviews).then(reviewsArr => {
                    return ReactDOM.render(
                        <TopReviews
                            title={title}
                            reviews={reviewsArr}
                        />,
                        element,
                    );
                }).catch(e => {
                    // tslint:disable-next-line: no-console
                    console.log('Could not render top reviews component: ' +  e);
                });
            }
        }).catch((r) => {
            // tslint:disable-next-line: no-console
            console.log('Could not retrieve top reviews from api: ' +  r);
        });
    });
}

function truncateReview(review: Review, url?: string): Review {
    return {
        title: review.title,
        name: review.name,
        date: review.date,
        body: review.body.split(' ').slice(0, 35).join(' '),
        key: review.key,
        link_href: url ? url : undefined,
    };
}

interface ProductPageV2 {
    id: number;
    meta: {
        type: string,
        detail_url: string,
        html_url: string,
        slug: string,
        first_published_at: string,
    };
    title: string;
    product_sku: string;
}

const getURL = async (sku: string, productId?: string): Promise<string | null> => {
    const response = await fetch(`${BASE_URL}/api/v2/pages/?type=blog.ProductPageV2&fields=product_sku`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
    });
    try {
        return await response.json().then(r => {
            const items: {
                [id: number]: ProductPageV2,
            } = r ? r.items : {};

            const urls = items ? Object.keys(items)
                .map((key, index) => items[key])
                .filter(item => item.product_sku ? item.product_sku === sku : false)
                .map(item => item.meta && item.meta.slug && productId ? BASE_URL + '/store/' + item.meta.slug + '?review_id=' + productId :
                             item.meta && item.meta.slug ? BASE_URL + '/store/' + item.meta.slug : null) : undefined;

            return urls ? urls.length > 0 ? urls[0] : null : null;
        });
    } catch  (error) {
        // tslint:disable-next-line: no-console
        console.log('Could not get review url: ' + error);
        throw Promise.reject(null);
    }
};

interface ReviewResponse {
    reviews: {
        [id: number]: {
            title: string;
            name: string;
            date: string;
            body: string;
            key: number;
        },
    };
}

const getFiveStarReviews = async (): Promise<ReviewResponse | null> => {
    const response = await fetch(`${BASE_API_URL}/v1/product/five-star-reviews/`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
    });
    try {
        return await response.json();
    } catch  (error) {
        throw Promise.reject(null);
    }
};
